/*eslint-disable */
import React from "react";
import { Button, Modal, Dropdown, Form, Segment, Input, Label } from "semantic-ui-react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import { Form as FormUi } from "semantic-ui-react";
import { MyNormalInput } from "../dynamicComponent/myInputs";
import { DateData } from "../dynamicComponent/datepick";
import SearchDropdown from "../createShipmentComponent/searchDropdown";
import CreatAxios from "../axiosComponent/create";
import UpdateAxios from "../axiosComponent/update";
import {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
} from "../../redux/actions/alertAction";
import { connect } from "react-redux";
import * as moment from "moment";
import { translate } from "react-i18next";
import { FormGroup } from "react-bootstrap";

const EditRateChart = ({
  values,
  touched,
  errors,
  t,
  editData,
  usersList,
  CloseModal,
  rateChart,
  setFieldValue,
  handleSubmit,
}) => {
  return (
    <Modal
      onClose={CloseModal}
      open={rateChart}
      size="large"
      className="p-overflow-initial"
    >
      <Modal.Header>{t("title")}</Modal.Header>
      <Modal.Content>
        <Formiker>
          <div className="ui form">

            <Segment>
              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">Engine Type</label>
                </FormUi.Field>
                <FormUi.Field width={4} >
                  <Dropdown
                    name=""
                    clearable
                    style={{ width: "100%", fontWeight: "normal" }}
                    selection
                    placeholder=""
                    value=""
                  />
                </FormUi.Field>
                <FormUi.Field width="2" />
                <FormUi.Field width={3}>
                  <label className="labelName">Rate Type</label>
                </FormUi.Field>
                <FormUi.Field width={4} >
                  <Dropdown
                    name=""
                    clearable
                    style={{ width: "100%", fontWeight: "normal" }}
                    selection
                    placeholder=""
                    value=""
                  />
                </FormUi.Field>
              </FormUi.Group>

              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">Expense Particular</label>
                </FormUi.Field>
                <FormUi.Field width={4} >
                  <Dropdown
                    name=""
                    clearable
                    style={{ width: "100%", fontWeight: "normal" }}
                    selection
                    placeholder=""
                    value=""
                  />
                </FormUi.Field>
                <FormUi.Field width="2" />
                <FormUi.Field width={3}>
                  <label className="labelName">Billy Party</label>
                </FormUi.Field>
                <FormUi.Field width={4} >
                  <Dropdown
                    name=""
                    clearable
                    style={{ width: "100%", fontWeight: "normal" }}
                    selection
                    placeholder=""
                    value=""
                  />
                </FormUi.Field>
              </FormUi.Group>

              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">Route</label>
                </FormUi.Field>
                <FormUi.Field width={4} >
                  <Dropdown
                    name=""
                    clearable
                    style={{ width: "100%", fontWeight: "normal" }}
                    selection
                    placeholder=""
                    value=""
                  />
                </FormUi.Field>
                <FormUi.Field width="2" />
                <FormUi.Field width={3}>
                  <label className="labelName">Vehicle Type</label>
                </FormUi.Field>
                <FormUi.Field width={4} >
                  <Dropdown
                    name=""
                    clearable
                    style={{ width: "100%", fontWeight: "normal" }}
                    selection
                    placeholder=""
                    value=""
                  />
                </FormUi.Field>
              </FormUi.Group>

              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">Consignor</label>
                </FormUi.Field>
                <FormUi.Field width={4} >
                  <Dropdown
                    name=""
                    clearable
                    style={{ width: "100%", fontWeight: "normal" }}
                    selection
                    placeholder=""
                    value=""
                  />
                </FormUi.Field>
                <FormUi.Field width="2" />
                <FormUi.Field width={3}>
                  <label className="labelName">Consignee</label>
                </FormUi.Field>
                <FormUi.Field width={4} >
                  <Dropdown
                    name=""
                    clearable
                    style={{ width: "100%", fontWeight: "normal" }}
                    selection
                    placeholder=""
                    value=""
                  />
                </FormUi.Field>
              </FormUi.Group>


              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">Vendor</label>
                </FormUi.Field>
                <FormUi.Field width={4} >
                  <Dropdown
                    name=""
                    clearable
                    style={{ width: "100%", fontWeight: "normal" }}
                    selection
                    placeholder=""
                    value=""
                  />
                </FormUi.Field>
                <FormUi.Field width="2" />
                <FormUi.Field width={3}>
                  <label className="labelName">Unit of Measurement</label>
                </FormUi.Field>
                <FormUi.Field width={4} >
                  <Dropdown
                    name=""
                    clearable
                    style={{ width: "100%", fontWeight: "normal" }}
                    selection
                    placeholder=""
                    value=""
                  />
                </FormUi.Field>
              </FormUi.Group>


              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">Amount</label>
                </FormUi.Field>
                <FormUi.Field width={4} >
                  <Input type="text" placeholder='Amount'>

                  </Input>
                </FormUi.Field>
                <FormUi.Field width="2" />
                <FormUi.Field width={3}>
                  <label className="labelName">Trip Type</label>
                </FormUi.Field>
                <FormUi.Field width={4} >
                  <Dropdown
                    name=""
                    clearable
                    style={{ width: "100%", fontWeight: "normal" }}
                    selection
                    placeholder=""
                    value=""
                  />
                </FormUi.Field>
              </FormUi.Group>

              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">Branch</label>
                </FormUi.Field>
                <FormUi.Field width={4} >
                  <Dropdown
                    name=""
                    clearable
                    style={{ width: "100%", fontWeight: "normal" }}
                    selection
                    placeholder=""
                    value=""
                  />
                </FormUi.Field>
                <FormUi.Field width="2" />
                <FormUi.Field width={3}>
                  <label className="labelName">Load Type</label>
                </FormUi.Field>
                <FormUi.Field width={4} >
                  <Dropdown
                    name=""
                    clearable
                    style={{ width: "100%", fontWeight: "normal" }}
                    selection
                    placeholder=""
                    value=""
                  />
                </FormUi.Field>
              </FormUi.Group>

              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">Movement Type</label>
                </FormUi.Field>
                <FormUi.Field width={4} >
                  <Dropdown
                    name=""
                    clearable
                    style={{ width: "100%", fontWeight: "normal" }}
                    selection
                    placeholder=""
                    value=""
                  />
                </FormUi.Field>
                <FormUi.Field width="2" />
                <FormUi.Field width={3}>
                  <label className="labelName">Container Type</label>
                </FormUi.Field>
                <FormUi.Field width={4} >
                  <Dropdown
                    name=""
                    clearable
                    style={{ width: "100%", fontWeight: "normal" }}
                    selection
                    placeholder=""
                    value=""
                  />
                </FormUi.Field>
              </FormUi.Group>


              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">Weight Slab Range</label>
                </FormUi.Field>
                <FormUi.Field width={4} >
                  <Dropdown
                    name=""
                    clearable
                    style={{ width: "100%", fontWeight: "normal" }}
                    selection
                    placeholder=""
                    value=""
                  />
                </FormUi.Field>
                <FormUi.Field width="2" />

              </FormUi.Group>
            </Segment>

            <Segment>
              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">Start Date</label>
                </FormUi.Field>
                <FormUi.Field width={4} >
                  <DateData
                    name="start_date"
                    autoComplete="off"
                    showTimeSelect
                    timeFormat="HH:mm"
                    popperClassName="dateTime"
                    dateFormat="dd/MM/yyyy HH:mm"
                    timeIntervals={5}
                    customInput={
                      <FormUi.Input
                        icon="time"
                        className="dateWidth"
                        iconPosition="left"
                      />
                    }
                  />
                </FormUi.Field>
                <FormUi.Field width="2" />
                <FormUi.Field width={2}>
                  <label className="labelName">End Date</label>
                </FormUi.Field>
                <FormUi.Field width={4} >
                  <DateData
                    name="end_date"
                    autoComplete="off"
                    showTimeSelect
                    timeFormat="HH:mm"
                    popperClassName="dateTime"
                    dateFormat="dd/MM/yyyy HH:mm"
                    timeIntervals={5}
                    customInput={
                      <FormUi.Input
                        icon="time"
                        className="dateWidth"
                        iconPosition="left"
                      />
                    }
                  />
                </FormUi.Field>
              </FormUi.Group>

            </Segment>






            <FormUi.Group inline>
              <FormUi.Field width="2">
                <label className="labelName">{t('table_header.source')}</label>
              </FormUi.Field>
              <FormUi.Field
                width="4"
                error={
                  touched.consignor_code && errors.consignor_code ? true : false
                }
              >
                {/* <Fieldmik name="consignor_code" component={MyNormalInput} /> */}
                <SearchDropdown
                  key={values.consignor_code_title}
                  setField={(name, data) => {
                    setFieldValue("consignor_code", data.key);
                    setFieldValue("consignor_code_title", data.title);
                  }}
                  masterRoute="consignorMaster"
                  masterRouteKey="consignorCode"
                  masterRouteName="consignorName"
                  fieldName="consignor_code"
                  deafultValue={values.consignor_code_title}
                />
                {touched.consignor_code && errors.consignor_code ? (
                  <div>{errors.consignor_code}</div>
                ) : null}
              </FormUi.Field>
              <FormUi.Field width="2" />
              <FormUi.Field width="2">
                <label className="labelName">{t("table_header.destination")}</label>
              </FormUi.Field>
              <FormUi.Field
                width="4"
                error={
                  touched.consignee_code && errors.consignee_code ? true : false
                }
              >
                {/* <Fieldmik name="consignee_code" component={MyNormalInput} /> */}
                <SearchDropdown
                  key={values.consignee_code_title}
                  setField={(name, data) => {
                    setFieldValue("consignee_code", data.key);
                    setFieldValue("consignee_code_title", data.title);
                  }}
                  masterRoute="consigneeMaster"
                  masterRouteKey="consigneeCode"
                  masterRouteName="consigneeName"
                  fieldName="consignee_code"
                  deafultValue={values.consignee_code_title}
                />
                {touched.consignee_code && errors.consignee_code ? (
                  <div>{errors.consignee_code}</div>
                ) : null}
              </FormUi.Field>
            </FormUi.Group>
            <FormUi.Group inline>
              <FormUi.Field width="2">
                <label className="labelName">{t("table_header.vehicle_type")}</label>
              </FormUi.Field>
              <FormUi.Field
                width="4"
                error={
                  touched.vehicle_type_code && errors.vehicle_type_code
                    ? true
                    : false
                }
              >
                {/* <Fieldmik name="vehicle_type_code" component={MyNormalInput} /> */}
                <SearchDropdown
                  key={values.vehicle_type_title}
                  setField={(name, data) => {
                    setFieldValue("vehicle_type_code", data.key);
                    setFieldValue("vehicle_type_title", data.title);
                  }}
                  masterRoute="vehicleTypeMaster"
                  masterRouteKey="vehicleTypeCode"
                  masterRouteName="vehicleType"
                  fieldName="vehicle_type_code"
                  deafultValue={values.vehicle_type_title}
                />
                {touched.vehicle_type_code && errors.vehicle_type_code ? (
                  <div>{errors.vehicle_type_code}</div>
                ) : null}
              </FormUi.Field>
              <FormUi.Field width="2" />
              <FormUi.Field width="2">
                <label className="labelName">{t("table_header.freight_rate")}</label>
              </FormUi.Field>
              <FormUi.Field
                width="4"
                error={
                  touched.freight_rate && errors.freight_rate ? true : false
                }
              >
                <Fieldmik
                  name="freight_rate"
                  type="number"
                  component={MyNormalInput}
                />
                {touched.freight_rate && errors.freight_rate ? (
                  <div>{errors.freight_rate}</div>
                ) : null}
              </FormUi.Field>
            </FormUi.Group>
            <FormUi.Group inline>
              <FormUi.Field width="2">
                <label className="labelName">{t("table_header.start_date")}</label>
              </FormUi.Field>
              <FormUi.Field
                width="4"
                error={touched.start_date && errors.start_date ? true : false}
              >
                <DateData
                  name="start_date"
                  autoComplete="off"
                  showTimeSelect
                  timeFormat="HH:mm"
                  popperClassName="dateTime"
                  dateFormat="dd/MM/yyyy HH:mm"
                  timeIntervals={5}
                  customInput={
                    <FormUi.Input
                      icon="time"
                      className="dateWidth"
                      iconPosition="left"
                    />
                  }
                />
                {touched.start_date && errors.start_date ? (
                  <div>{errors.start_date}</div>
                ) : null}
              </FormUi.Field>
              <FormUi.Field width="2" />
              <FormUi.Field width="2">
                <label className="labelName">{t("table_header.end_date")}</label>
              </FormUi.Field>
              <FormUi.Field
                width="4"
                error={touched.end_date && errors.end_date ? true : false}
              >
                <DateData
                  name="end_date"
                  autoComplete="off"
                  showTimeSelect
                  timeFormat="HH:mm"
                  popperClassName="dateTime"
                  dateFormat="dd/MM/yyyy HH:mm"
                  timeIntervals={5}
                  customInput={
                    <FormUi.Input
                      icon="time"
                      className="dateWidth"
                      iconPosition="left"
                    />
                  }
                />
                {touched.end_date && errors.end_date ? (
                  <div>{errors.end_date}</div>
                ) : null}
              </FormUi.Field>
            </FormUi.Group>
            <FormUi.Group inline>
              <FormUi.Field width="2">
                <label className="labelName">{t("table_header.type")}</label>
              </FormUi.Field>
              <FormUi.Field
                width="4"
                error={
                  touched.operation_type && errors.operation_type ? true : false
                }
              >
                <Dropdown
                  name="operation_type"
                  clearable
                  style={{ width: "100%", fontWeight: "normal" }}
                  selection
                  placeholder={t("type")}
                  onChange={(name, data) =>
                    setFieldValue("operation_type", data.value)
                  }
                  options={[
                    { key: "1", text: "Transfers", value: "transfers" },
                    { key: "2", text: "Import", value: "import" },
                    { key: "3", text: "Primary", value: "primary" },
                  ]}
                  value={values.operation_type}
                />{" "}
                {touched.operation_type && errors.operation_type ? (
                  <div>{errors.operation_type}</div>
                ) : null}
              </FormUi.Field>
            </FormUi.Group>
          </div>
        </Formiker>
      </Modal.Content>
      <Modal.Actions>
        <Button color="green" size="mini" type="button" onClick={CloseModal}>
          {t("cancel")}
        </Button>
        <Button size="mini" color="blue" onClick={() => handleSubmit()}>
          {t("ok")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const RateChartFormik = withFormik({
  enableReinitialize: true,
  mapPropsToValues: (props) => {
    return {
      operation_type: props.editData.operation_type || "",
      freight_rate: props.editData.freight_rate || "",
      consignor_code: props.editData.consignorCode || "",
      consignee_code: props.editData.consigneeCode || "",
      vehicle_type_code: props.editData.vehicleTypeCode || "",
      start_date: props.editData.start_date
        ? moment(props.editData.start_date, "DD-MM-YYYY").format("YYYY-MM-DD")
        : "",
      end_date: props.editData.end_date
        ? moment(props.editData.end_date, "DD-MM-YYYY").format("YYYY-MM-DD")
        : "",
      vendor_code: props.vendor_code || "",
      //   to set search dropdwon deafult value
      consignee_code_title: props.editData.consigneeName || "",
      consignor_code_title: props.editData.consignorName || "",
      vehicle_type_title: props.editData.vehicleType || "",
    };
  },
  validationSchema: yup.object({
    operation_type: yup.string().required("required"),
    freight_rate: yup.number().required("required").min(1, "min"),
    consignor_code: yup.string().required("required").nullable(),
    consignee_code: yup.string().required("required").nullable(),
    vehicle_type_code: yup.string().required("required"),
    vendor_code: yup.string().required("required"),
    start_date: yup.string().required("required").nullable(),
    end_date: yup.string().required("required").nullable(),
  }),
  async handleSubmit(values, { props }) {
    if (props.editData.vendor_rate_id) {
      await UpdateAxios({
        completeURL: `${process.env.REACT_APP_MASTER_API_TWO}/vendor/rate/${props.editData.vendor_rate_id}`,
        payload: { ...values },
      })
        .then((res) => {
          let alert = {
            type: "success",
            messageHeader: "Success",
            messageBody: "Vendor Rate is updated.",
          };
          props.successAlertDispatcher(alert);
          props.CloseModal();
          props.onFormSubmit();
        })
        .catch((err) => {
          let alert = {
            type: "error",
            messageHeader: "Error",
            messageBody: "Unable to update vendor rate.",
          };
          console.log(err);
          props.errorAlertDispatcher(alert);
        });
    } else {
      await CreatAxios({
        completeURL: `${process.env.REACT_APP_MASTER_API_TWO}/vendor/rate`,
        payload: { ...values },
      })
        .then((res) => {
          let alert = {
            type: "success",
            messageHeader: "Success",
            messageBody: "New vendor rate is created.",
          };
          props.successAlertDispatcher(alert);
          props.CloseModal();
          props.onFormSubmit();
        })
        .catch((err) => {
          console.log(err);
          let alert = {
            type: "error",
            messageHeader: "Error",
            messageBody: "Unable to create new vendor Rate.",
          };
          props.errorAlertDispatcher(alert);
        });
    }
  },
})(EditRateChart);

export default connect(null, {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
})(translate('rate_chart')(RateChartFormik));
